/* eslint-disable @typescript-eslint/ban-ts-comment */
import isEmpty from 'lodash/isEmpty'
import { captureException } from '@sentry/react'

export interface DeviceStats {
  kind: MediaDeviceInfo['kind']
  deviceId: MediaDeviceInfo['deviceId']
  label: MediaDeviceInfo['label']
  capabilities: MediaTrackCapabilities
}

async function getDefaultAudioInputDevice (): Promise<MediaDeviceInfo | void> {

  let devices: MediaDeviceInfo[] = []
  
  try {
    
    devices = await navigator.mediaDevices.enumerateDevices()

  }
  catch (e) {

    captureException(e)

  }

  const defaultDevice = devices.find((device) => (device.deviceId === 'default' || device.deviceId === 'communications') && device.kind.match(/audioinput/))
  if (!defaultDevice) return
  return devices.find((device) => device.groupId === defaultDevice.groupId && device.deviceId !== 'default' && device.deviceId !== 'communications')

}

async function getVideoInputDevices (): Promise<MediaDeviceInfo[]> {

  let devices: MediaDeviceInfo[] = []
  
  try {
    
    devices = await navigator.mediaDevices.enumerateDevices()

  }
  catch (e) {

    captureException(e)

  }

  return devices.filter((device) => device.kind.match(/videoinput/))

}

async function checkPermissions (): Promise<DeviceStats[]> {

  let devices: MediaDeviceInfo[] = []

  const devicesWithPermissions: DeviceStats[] = []

  try {

    devices = await navigator.mediaDevices.enumerateDevices()

  }
  catch (e) {

    captureException(e)

  }

  for (const device of devices) {

    if (!device.kind.match(/input/)) continue

    try {

      // @ts-ignore
      const deviceCapabilities = await device.getCapabilities()
      if (!isEmpty(deviceCapabilities)) {

        devicesWithPermissions.push({
          kind: device.kind,
          deviceId: device.deviceId,
          label: device.label,
          capabilities: deviceCapabilities

        })

      }

    }
    catch (e) {

      captureException(e)

    }

  }

  return devicesWithPermissions

}

export default {
  getDefaultAudioInputDevice,
  getVideoInputDevices,
  checkPermissions
}
